import React, { useCallback, useMemo, useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col } from 'reactstrap';
import { APPROVED, AWARDED, CANCELLED, DRAFT, EMPTY_DATA, FILE_URL, NON_AWARDED, PREDRAFT, RECEIVED, REJECTED, RETURNED, RFQ, RFQAPPROVALTYPEID, RFQVendor, SENT, SUBMITTED, UNDER_APPROVAL, UNDER_REVISION, } from '../.././config/constants'
import NoContentFound from '.././common/NoContentFound';
import { MESSAGES } from '../.././config/message';
import Toaster from '.././common/Toaster';
import 'react-input-range/lib/css/index.css'
import LoaderCustom from '.././common/LoaderCustom';
import { AgGridColumn, AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-material.css';
import PopupMsgWrapper from '.././common/PopupMsgWrapper';
import { getQuotationList, cancelRfqQuotation, getApprovalsByFilter, getQuotationById } from './actions/rfq';
import { checkFinalUser } from '../costing/actions/Costing';
import ViewRfq from './ViewRfq';
import AddRfq from './AddRfq';
import { checkPermission, encodeQueryParamsAndLog, getConfigurationKey, getTimeZone, loggedInUserId, removeSpaces, RFQ_KEYS, searchNocontentFilter, setLoremIpsum, showBopLabel, userDetails } from '../../helper';
import DayTime from '../common/DayTimeWrapper';
import Attachament from '../costing/components/Drawers/Attachament';
import SingleDropdownFloationFilter from '../masters/material-master/SingleDropdownFloationFilter';
import { agGridStatus, getGridHeight } from '../../actions/Common';
import TourWrapper from '../common/Tour/TourWrapper';
import { Steps } from '../common/Tour/TourMessages';
import { useTranslation } from 'react-i18next';
import CustomCellRenderer from './CommonDropdown';
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom";
import { PaginationWrappers } from '../common/Pagination/PaginationWrappers';
import PaginationControls from '../common/Pagination/PaginationControls';
import { resetStatePagination, updateCurrentRowIndex, updateGlobalTake, updatePageNumber, updatePageSize } from '../common/Pagination/paginationAction';
import { reactLocalStorage } from 'reactjs-localstorage';
import { setSelectedRowForPagination } from '../simulation/actions/Simulation';
import WarningMessage from '../common/WarningMessage';
import { useLabels } from '../../helper/core';
import Button from '../layout/Button';
import RemarkHistoryDrawer from './RemarkHistoryDrawer';
import RFQApprovalDrawer from './components/RFQApprovalDrawer';
import { costingTypeIdToApprovalTypeIdFunction, getRFQIdByPartType } from '../common/CommonFunctions';
import _ from 'lodash';
import { statusDropdownforRfq } from '../../config/masterData';
export const ApplyPermission = React.createContext();
const gridOptions = {};



// Use centralized helper from CommonFunctions to map RFQ PartType to RFQ Approval Id

function RfqListing(props) {
    const { isApprovalTab = false, isDashboard = false, status: dashboardStatus = '' } = props;

    const [gridApi, setgridApi] = useState(null);                      // DONT DELETE THIS STATE , IT IS USED BY AG GRID
    const [loader, setloader] = useState(false);
    const dispatch = useDispatch();
    const [addRfqData, setAddRfqData] = useState({});
    const [rowData, setRowData] = useState([])
    const [totalRecordCount, setTotalRecordCount] = useState(0)
    const [noData, setNoData] = useState(false)
    const [viewRfq, setViewRfq] = useState(false)
    const [closeViewRfq, setCloseViewRfq] = useState(false)
    const [viewRfqData, setViewRfqData] = useState("")
    const [addAccessibility, setAddAccessibility] = useState(false);
    const [editAccessibility, setEditAccessibility] = useState(false);
    const [viewAccessibility, setViewAccessibility] = useState(false);
    const [confirmPopup, setConfirmPopup] = useState(false);
    const [attachment, setAttachment] = useState(false);
    const [viewAttachment, setViewAttachment] = useState([])
    const [deleteId, setDeleteId] = useState('');
    const { t } = useTranslation("Common");
    const [showAddFrom, setShowAddFrom] = useState(false)
    const [showExtraData, setShowExtraData] = useState(false)
    const [finalUserDetails, setFinalUserDetails] = useState(null);
    const [render, setRender] = useState(false)
    const [permissionData, setPermissionData] = useState()
    const [isFilterButtonClicked, setIsFilterButtonClicked] = useState(false)
    const { globalTakes } = useSelector((state) => state.pagination);
    const { selectedRowForPagination } = useSelector((state) => state.simulation); // For pagination selection persistence
    const [warningMessage, setWarningMessage] = useState(false)
    const [remarkHistoryDrawer, setRemarkHistoryDrawer] = useState(false)
    const [remarkRowData, setRemarkRowData] = useState([])

    // State for Send for Approval functionality
    const [selectedRows, setSelectedRows] = useState([]);
    const [disableApprovalButton, setDisableApprovalButton] = useState(true);
    const [sendForApprovalDrawerOpen, setSendForApprovalDrawerOpen] = useState(false);

    // State for RFQ Approval from Listing (approve mode)
    const [rfqDrawerMode, setRfqDrawerMode] = useState('create');
    const [rfqIsFinalApprover, setRfqIsFinalApprover] = useState(false);
    const [rfqApprovalNumber, setRfqApprovalNumber] = useState(null);
    const [rfqApprovalProcessId, setRfqApprovalProcessId] = useState(null);
    const [rfqDataForApproval, setRfqDataForApproval] = useState(null);

    // State for RFQ Approve/Reject drawer
    const [showApproveRejectDrawer, setShowApproveRejectDrawer] = useState(false);
    const [approveRejectDetails, setApproveRejectDetails] = useState({});

    const [floatingFilterData, setFloatingFilterData] = useState({
        QuotationNumber: "",
        PartType: "",
        PartNumber: "",
        RawMaterial: "",
        NoOfQuotationReceived: "",
        VendorName: "", // Will be mapped to vendorCode in API call
        PlantName: "", // Will be mapped to plantCode in API call
        TechnologyName: "",
        RaisedBy: "",
        RaisedOn: "",
        PartDataSentDate: "",
        VisibilityMode: "",
        VisibilityDate: "",
        VisibilityDuration: "",
        LastSubmissionDate: "",
        Status: "",
        BoughtOutPart: "", // Will be mapped to boughtOutPart in API call
        PRNumber: "",
        Notes: "",
        // Approval-specific filters
        ApprovalNumber: "",
        InitiatedBy: "",
        CreatedOn: "",
        LastApprovedBy: "",
        RequestedOn: "",
    });

    const [filterModel, setFilterModel] = useState({});
    const { technologyLabel, vendorLabel } = useLabels();

    const { topAndLeftMenuData } = useSelector(state => state.auth);
    const approvalStatusList = useSelector((state) => state?.rfq?.approvalStatusList);
    const agGridRef = useRef(null);
    const statusColumnData = useSelector((state) => state.comman.statusColumnData);
    const history = useHistory();
    const location = useLocation();
    const initialConfiguration = useSelector((state) => state.auth.initialConfiguration)
    const hideRemarkHistoryIcon = initialConfiguration?.IsManageSeparateUserPermissionForPartAndVendorInRaiseRFQ;


    useEffect(() => {
        return () => {
            // Cleanup selections on unmount
            dispatch(setSelectedRowForPagination([]))
            setSelectedRows([])
            dispatch(resetStatePagination());
        }
    }, [])

    useEffect(() => {
        if (!isApprovalTab && !isDashboard) {
            if (rowData?.length > 0) {
                setTotalRecordCount(rowData[0].TotalRecordCount)
            }
            return;
        }
        // When on Approval tab or Dashboard, take count from reducer, fallback to first row's TotalRecordCount
        if (isApprovalTab || isDashboard) {
            // Priority 1: Use reducer's totalCount
            if (approvalStatusList?.totalCount !== undefined && approvalStatusList.totalCount !== null) {
                setTotalRecordCount(approvalStatusList.totalCount);
            }
            // Priority 2: Extract from first row's TotalRecordCount
            else if (approvalStatusList?.data?.length > 0) {
                const firstRowCount = approvalStatusList.data[0]?.TotalRecordCount;
                if (firstRowCount !== undefined && firstRowCount !== null) {
                    setTotalRecordCount(firstRowCount);
                }
            }
        }
    }, [rowData, isApprovalTab, isDashboard, approvalStatusList])

    /**
     * Restore checkbox selections after page navigation
     * Similar to CommonApproval.js:461-498 (linkableFormatter selection restoration)
     */
    useEffect(() => {
        if ((!isApprovalTab && !isDashboard) || !gridApi || !rowData || !selectedRowForPagination || selectedRowForPagination.length === 0) {
            return;
        }

        // Wait for grid to render, then restore selections
        setTimeout(() => {
            gridApi.forEachNode((node) => {
                if (node.data) {
                    // Check if this row exists in Redux (was selected on another page)
                    const isSelected = selectedRowForPagination.some(
                        item => item?.QuotationId === node.data?.QuotationId
                    );

                    if (isSelected) {
                        node.setSelected(true);
                    }
                }
            });
        }, 100);
    }, [rowData, isApprovalTab, gridApi, selectedRowForPagination]);

    useEffect(() => {
        if (topAndLeftMenuData) {
            try {
                dispatch(agGridStatus("", ""))

                // Reset filters when component mounts or tab switches
                setFloatingFilterData(prevState => {
                    const resetData = { ...prevState };
                    for (var prop in resetData) {
                        const configKey = getConfigurationKey();

                        if (configKey && configKey.IsCompanyConfigureOnPlant) {
                            if (prop !== "DepartmentName") {
                                resetData[prop] = ""
                            }
                        } else {
                            resetData[prop] = ""
                        }
                    }
                    return resetData;
                });

                setWarningMessage(false);
                setIsFilterButtonClicked(false);
                setNoData(false);

                // Reset grid state
                setTimeout(() => {
                    if (gridOptions?.columnApi) {
                        gridOptions.columnApi.resetColumnState(null);
                    }
                    if (gridOptions?.api) {
                        gridOptions.api.setFilterModel(null);
                    }
                }, 100);

                // Fetch data for the current tab
                getDataList(0, globalTakes, true)

                applyPermission(topAndLeftMenuData)
            } catch (error) {
                setloader(false);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [topAndLeftMenuData, isApprovalTab, isDashboard, dashboardStatus])

    useEffect(() => {
        // Only set filter if coming from status column and not from ViewRfq close
        if (statusColumnData?.data && !closeViewRfq && !viewRfq) {
            // setWarningMessage(true);
            setFloatingFilterData(prevState => ({
                ...prevState,
                Status: removeSpaces(statusColumnData.data)
            }));
        }
    }, [statusColumnData, closeViewRfq]);
    useEffect(() => {
        const { source, quotationId } = location.state || {};

        if (source === 'auction') {
            if (rowData && rowData.length !== 0) {
                const fiterRowData = rowData.find(item => item?.QuotationId === quotationId);
                viewDetails(fiterRowData);
            }
        }
    }, [rowData])
    useEffect(() => {
        const handleBeforeUnload = (event) => {
            history.push({
                pathname: '/rfq-listing',
                state: { source: 'rfq' }
            })
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []);
    // Create base filter params
    const baseFilterParams = {
        date: "",
        inRangeInclusive: true,
        filterOptions: ['equals', 'inRange'],
        browserDatePicker: true,
        minValidYear: 2000,
    };

    // Simplified date comparator function
    const createDateComparator = (fieldName) => (filterLocalDateAtMidnight, cellValue) => {
        var dateAsString = cellValue != null ? DayTime(cellValue).format('DD/MM/YYYY') : '';
        var newDate = filterLocalDateAtMidnight != null ? DayTime(filterLocalDateAtMidnight).format('DD/MM/YYYY') : '';

        setDate(newDate, fieldName);

        // Handle radio button click
        let date = document.getElementsByClassName('ag-input-field-input')
        for (let i = 0; i < date.length; i++) {
            if (date[i].type == 'radio') {
                date[i].click()
            }
        }

        if (dateAsString == null) return -1;
        var dateParts = dateAsString.split('/');
        var cellDate = new Date(
            Number(dateParts[2]),
            Number(dateParts[1]) - 1,
            Number(dateParts[0])
        );

        return filterLocalDateAtMidnight.getTime() === cellDate.getTime() ? 0
            : cellDate < filterLocalDateAtMidnight ? -1 : 1;
    };

    // Simplified filter params
    const raisedOnFilterParams = {
        ...baseFilterParams,
        comparator: createDateComparator('RaisedOn')
    };

    const partDataSentFilterParams = {
        ...baseFilterParams,
        comparator: createDateComparator('PartDataSentDate')
    };

    const visibilityDateFilterParams = {
        ...baseFilterParams,
        comparator: createDateComparator('VisibilityDate')
    };

    const lastSubmissionDateFilterParams = {
        ...baseFilterParams,
        comparator: createDateComparator('LastSubmissionDate')
    };

    /**
     * @method applyPermission
     * @description ACCORDING TO PERMISSION HIDE AND SHOW, ACTION'S
     */
    const applyPermission = (topAndLeftMenuData) => {
        if (topAndLeftMenuData !== undefined) {
            const Data = topAndLeftMenuData && topAndLeftMenuData.find(el => el?.ModuleName === RFQ);
            const accessData = Data && Data.Pages.find(el => el?.PageName === RFQ)
            const permmisionData = accessData && accessData.Actions && checkPermission(accessData.Actions)
            const accessDataVendor = Data && Data.Pages.find(el => el?.PageName === RFQVendor)
            const permmisionDataVendor = accessDataVendor && accessDataVendor.Actions && checkPermission(accessDataVendor.Actions)

            if (permmisionData !== undefined || permmisionDataVendor !== undefined) {
                setPermissionData({
                    permissionDataPart: permmisionData,
                    permissionDataVendor: permmisionDataVendor
                });
                setAddAccessibility(permmisionData && permmisionData.Add ? permmisionData.Add : false)
                setEditAccessibility(permmisionData && permmisionData.Edit ? permmisionData.Edit : false)
                setViewAccessibility(permmisionData && permmisionData.View ? permmisionData.View : false)
            }
        }
    }

    const setDate = (date, column) => {


        // Map column names to state fields
        const fieldMapping = {
            'RaisedOn': 'RaisedOn',
            'PartDataSentDate': 'PartDataSentDate',
            'VisibilityDate': 'VisibilityDate',
            'LastSubmissionDate': 'LastSubmissionDate'
        };

        // Get the correct field name
        const fieldName = fieldMapping[column] || column;

        setFloatingFilterData(prevState => ({
            ...prevState,
            [fieldName]: date // Use the mapped field name
        }));
    };

    const getDataList = useCallback((skip = 0, take = 10, isPagination = true, isReset = false) => {
        if (isPagination) setloader(true);

        // Clear existing data before making new API call
        setRowData([]);
        setTotalRecordCount(0);

        // Get user details once to avoid multiple calls
        const currentUserDetails = userDetails();
        const currentUserId = loggedInUserId();

        // Validate required data
        if (!currentUserDetails?.DepartmentCode || !currentUserId) {
            setloader(false);
            Toaster.error('Unable to fetch data. User details missing.');
            return;
        }

        // Build common query parameters for both APIs
        const queryParams = {
            vendorId: '',
            departmentCode: currentUserDetails.DepartmentCode,
            loggedInUserId: currentUserId,
            isApplyPagination: isPagination,
            quotationNumber: floatingFilterData.QuotationNumber || '',
            partNumber: floatingFilterData.PartNumber || '',
            prNumber: floatingFilterData.PRNumber || '',
            rawMaterial: floatingFilterData.RawMaterial || '',
            boughtOutPart: floatingFilterData.BoughtOutPart || '',
            noOfQuotationReceived: floatingFilterData.NoOfQuotationReceived || '',
            vendorCode: floatingFilterData.VendorName || '',
            plantCode: floatingFilterData.PlantName || '',
            technologyName: floatingFilterData.TechnologyName || '',
            raisedBy: floatingFilterData.RaisedBy || '',
            raisedOn: floatingFilterData.RaisedOn || '',
            lastSubmissionDate: floatingFilterData.LastSubmissionDate || '',
            visibilityMode: floatingFilterData.VisibilityMode || '',
            visibilityDate: floatingFilterData.VisibilityDate || '',
            visibilityDuration: floatingFilterData.VisibilityDuration || '',
            status: isDashboard ? '' : (floatingFilterData.Status || ''),
            partType: floatingFilterData.PartType || '',
            partDataSentDate: floatingFilterData.PartDataSentDate || '',
            timeZone: getTimeZone(),
            notes: floatingFilterData.Remark || '',
            skip: skip,
            take: take
        };

        // Add approval-specific parameters if in approval tab or dashboard
        if (isApprovalTab || isDashboard) {
            queryParams.logged_in_user_level_id = currentUserDetails?.LoggedInLevelId || '';
            queryParams.isDashboard = isDashboard;
            queryParams.DisplayStatus = isDashboard ? dashboardStatus : (floatingFilterData.DisplayStatus || '');
            queryParams.ApprovalNumber = floatingFilterData.ApprovalNumber || '';
            queryParams.InitiatedBy = floatingFilterData.InitiatedBy || '';
            queryParams.CreatedOn = floatingFilterData.CreatedOn || '';
            queryParams.LastApprovedBy = floatingFilterData.LastApprovedBy || '';
            queryParams.RequestedOn = floatingFilterData.RequestedOn || '';
        }

        // Select API and prepare parameters
        const apiCall = (isApprovalTab || isDashboard) ? getApprovalsByFilter : getQuotationList;
        const apiParams = (isApprovalTab || isDashboard) ? queryParams : encodeQueryParamsAndLog(queryParams);

        // Make API call with error handling
        dispatch(apiCall(apiParams, (res) => {
            try {
                setloader(false);

                // Handle error responses
                if (!res) {
                    setTotalRecordCount(0);
                    setRowData([]);
                    dispatch(updatePageNumber(0));
                    return;
                }

                // Handle 204 No Content
                if (res.status === 204) {
                    setTotalRecordCount(0);
                    setRowData([]);
                    dispatch(updatePageNumber(0));
                    return;
                }

                // Handle successful response
                if (res.status === 200 && res?.data?.Result !== false) {
                    if (isApprovalTab || isDashboard) {
                        // Data handled by reducer; do not set local rowData here
                        const isResetFilter = !Object.values(floatingFilterData).some(value => value !== "");
                        setTimeout(() => {
                            if (gridOptions?.api?.setFilterModel) {
                                gridOptions.api.setFilterModel(isResetFilter ? {} : filterModel);
                            }
                        }, 300);
                        if (isFilterButtonClicked || isResetFilter) {
                            setWarningMessage(false);
                        }
                    } else {
                        const dataList = res?.data?.DataList || [];
                        if (!Array.isArray(dataList)) {
                            setRowData([]);
                            setTotalRecordCount(0);
                            dispatch(updatePageNumber(0));
                            return;
                        }
                        const formattedData = dataList.map(item => ({
                            ...item,
                            Status: item?.IsActive === false ? "Cancelled" : (item?.Status || ''),
                            tooltipText: (isApprovalTab || isDashboard) ? '' : getTooltipText(item?.Status)
                        }));
                        setRowData(formattedData);

                        // Get total count from response or first item
                        // For approval tab/dashboard, totalCount comes from reducer, so skip setting it here
                        if (!isApprovalTab && !isDashboard) {
                            let totalCount = 0;
                            if (res?.data?.TotalRecordCount || res?.data?.totalRecordCount) {
                                totalCount = res.data.TotalRecordCount || res.data.TotalRecordCount;
                            } else if (dataList.length > 0 && dataList[0]?.TotalRecordCount) {
                                totalCount = dataList[0].TotalRecordCount;
                            } else {
                                totalCount = dataList.length;
                            }
                            setTotalRecordCount(totalCount);
                        }

                        if (dataList.length === 0) {
                            dispatch(updatePageNumber(0));
                        }
                        // Handle filter model updates
                        const isResetFilter = !Object.values(floatingFilterData).some(value => value !== "");
                        setTimeout(() => {
                            if (gridOptions?.api?.setFilterModel) {
                                gridOptions.api.setFilterModel(isResetFilter ? {} : filterModel);
                            }
                        }, 300);
                        if (isFilterButtonClicked || isResetFilter) {
                            setWarningMessage(false);
                        }
                    }
                } else {
                    // Handle other status codes or failed responses
                    setRowData([]);
                    setTotalRecordCount(0);
                    dispatch(updatePageNumber(0));
                }
            } catch (error) {
                setloader(false);
                setRowData([]);
                setTotalRecordCount(0);
            }
        }));
    }, [floatingFilterData, filterModel, dispatch, isApprovalTab, isDashboard, dashboardStatus, isFilterButtonClicked]);

    const getTooltipText = useMemo(() => (status) => {
        switch (status) {
            case APPROVED: return 'Total no. of parts for which costing has been approved from that quotation / Total no. of parts exist in that quotation'
            case RECEIVED: return 'Total no. of costing received / Total no. of expected costing in that quotation'
            case UNDER_REVISION: return 'Total no. of costing under revision / Total no. of expected costing in that quotation'
            case DRAFT: return 'The token is pending to send for approval from your side.'
            case CANCELLED: return 'Quotation has been cancelled.'
            case SENT: return 'Costing under the quotation has been sent.'
            case REJECTED: return 'Quotation has been rejected.'
            case RETURNED: return 'Quotation has been returned.'
            case PREDRAFT: return 'Quotation pre-drafted, parts details saved.'
            default: return ''
        }
    }, [])

    const onFloatingFilterChanged = useCallback((value) => {
        const model = gridOptions?.api?.getFilterModel();
        setFilterModel(model);

        // Show warning when filter changes (reset isFilterButtonClicked to allow re-filtering)
        setWarningMessage(true);
        setIsFilterButtonClicked(false);

        // Handle filter changes
        if (value?.filterInstance?.appliedModel === null ||
            value?.filterInstance?.appliedModel?.filter === "") {
            // Clear the filter value
            setFloatingFilterData(prev => ({
                ...prev,
                [value.column.colId]: ""
            }));
        } else {
            // Handle date fields
            const dateFields = ['RaisedOn', 'PartDataSentDate', 'VisibilityDate', 'LastSubmissionDate'];

            if (dateFields.includes(value.column.colId)) {
                const dateValue = value.filterInstance.appliedModel.dateFrom;
                setFloatingFilterData(prev => ({
                    ...prev,
                    [value.column.colId]: dateValue ? DayTime(dateValue).format('DD/MM/YYYY') : ""
                }));
            } else {
                // Handle non-date fields
                setFloatingFilterData(prev => ({
                    ...prev,
                    [value.column.colId]: value.filterInstance.appliedModel.filter
                }));
            }
        }

        // Check for empty results
        setTimeout(() => {
            if (rowData.length !== 0) {
                setNoData(searchNocontentFilter(value, noData));
            }
        }, 500);
    }, [rowData, isFilterButtonClicked, noData]);

    const resetState = () => {
        setNoData(false)
        dispatch(agGridStatus("", ""))

        // setinRangeDate([])
        setIsFilterButtonClicked(false)
        gridOptions?.columnApi?.resetColumnState(null);
        gridOptions?.api?.setFilterModel(null);

        for (var prop in floatingFilterData) {

            if (getConfigurationKey().IsCompanyConfigureOnPlant) {
                if (prop !== "DepartmentName") {
                    floatingFilterData[prop] = ""
                }
            } else {
                floatingFilterData[prop] = ""
            }
        }

        setFloatingFilterData(floatingFilterData)
        setWarningMessage(false)
        dispatch(updatePageNumber(1))
        dispatch(updateCurrentRowIndex(10))
        getDataList(0, 10, true, true)
        dispatch(setSelectedRowForPagination([]))
        setSelectedRows([]) // Clear local selected rows state
        dispatch(updateGlobalTake(10))
        dispatch(updatePageSize({ pageSize10: true, pageSize50: false, pageSize100: false }))
        reactLocalStorage.setObject('selectedRow', {})

    }

    const onSearch = () => {
        setNoData(false)
        setWarningMessage(false)
        setIsFilterButtonClicked(true)
        dispatch(updatePageNumber(1))
        dispatch(updateCurrentRowIndex(10))
        gridOptions?.columnApi?.resetColumnState();
        getDataList(0, globalTakes, true, floatingFilterData)
    }

    /**
    * @method hideForm
    * @description HIDE DOMESTIC, IMPORT FORMS
    */

    const handleFilterChange = () => {
        // Enable filter button when Status dropdown changes
        setWarningMessage(true);
        setIsFilterButtonClicked(false);

        if (agGridRef.current) {
            setTimeout(() => {
                if (!agGridRef.current.rowRenderer.allRowCons.length) {
                    setNoData(true)
                    dispatch(getGridHeight({ value: 3, component: 'RFQ' }))
                } else {
                    setNoData(false)
                }
            }, 100);

        }
    };

    /**
     * Helper: Build checkFinalUser API payload
     * Reusable function to construct payload for checkFinalUser API calls
     */
    const buildCheckFinalUserPayload = useCallback((rowData) => {
        const ApprovalRFQId = getRFQIdByPartType(rowData?.PartType);
        const approvalTypeIdForApi = costingTypeIdToApprovalTypeIdFunction(RFQAPPROVALTYPEID ?? '10') || '10';

        return {
            DepartmentId: userDetails()?.DepartmentId || rowData?.DepartmentId || '',
            UserId: loggedInUserId(),
            TechnologyId: ApprovalRFQId,
            Mode: 'rfq',
            approvalTypeId: approvalTypeIdForApi,
            plantId: rowData?.PlantId || null,
            divisionId: rowData?.DivisionId || null
        };
    }, []);

    /**
     * Get filtered status dropdown based on approval tab or regular listing
     * For Approval Tab: Only show approval-relevant statuses
     * For Regular Listing: Show all statuses
     */
    const getFilteredStatusDropdown = useMemo(() => {
        if (isApprovalTab || isDashboard) {
            // Only show these statuses in approval listing
            const approvalRelevantStatuses = ["1", "2", "7", "9"]; // Approved, Draft, Rejected, Pending For Approval
            return statusDropdownforRfq.filter(status => approvalRelevantStatuses.includes(status.value));
        }
        // Show all statuses for regular listing
        return statusDropdownforRfq;
    }, [isApprovalTab, isDashboard]);

    const floatingFilterRFQ = useMemo(() => ({
        maxValue: 11,
        suppressFilterButton: true,
        component: "RFQ",
        onFilterChange: handleFilterChange,
        values: getFilteredStatusDropdown
    }), [isApprovalTab, isDashboard, getFilteredStatusDropdown]);
    //**  HANDLE TOGGLE EXTRA DATA */
    const toggleExtraData = (showTour) => {
        setRender(true)
        setTimeout(() => {
            setShowExtraData(showTour)
            setRender(false)
        }, 100);


    }


    /**
    * @method editItemDetails
    * @description edit material type
    */
    const viewOrEditItemDetails = (Id, rowData = {}, isViewMode, isEditMode) => {
        if (!Id) {
            Toaster.error('Quotation ID not found');
            return;
        }

        let data = {
            isEditFlag: isEditMode,
            isViewFlag: isViewMode,
            rowData: rowData,
            Id: Id,
            isAddFlag: false // Explicitly set this to false for edit mode

        }
        setAddRfqData(data)
        setShowAddFrom(true)
        resetState()
    }

    const cancelItem = (id) => {
        setConfirmPopup(true)
        setDeleteId(id)
    }

    const onPopupConfirm = () => {
        if (!deleteId) {
            Toaster.error('Quotation ID not found');
            setConfirmPopup(false);
            return;
        }
        dispatch(cancelRfqQuotation(deleteId, (res) => {
            if (res.status === 200) {
                Toaster.success('Quotation has been cancelled successfully.')
                setTimeout(() => {
                    getDataList()
                }, 500);
            }
            setConfirmPopup(false)
        }))
    }

    const closePopUp = () => {
        setConfirmPopup(false)
    }
    const getRemarkHistory = (cell, rowData) => {
        setRemarkRowData(rowData)

        setTimeout(() => {
            setRemarkHistoryDrawer(true)
        }, 500);

    }
    /**
    * @method buttonFormatter
    * @description Renders buttons
    */
    const buttonFormatter = (props) => {
        const cellValue = props?.valueFormatted ? props?.valueFormatted : props?.value;
        const rowData = props?.valueFormatted ? props?.valueFormatted : props?.data;
        let status = rowData?.Status;



        // Helper function to check if quotation is complete
        const isQuotationComplete = () => {
            return rowData?.CostingReceived === rowData?.TotalCostingCount &&
                rowData?.TotalCostingCount > 0;
        };

        // Helper function to check if status allows editing
        const isEditableStatus = () => {
            // Non-editable statuses
            const nonEditableStatuses = [
                APPROVED,
                REJECTED,
                AWARDED,
                NON_AWARDED,
                CANCELLED
            ];

            // If status is in non-editable list, return false
            if (nonEditableStatuses.includes(status)) {
                return false;
            }

            // For RECEIVED status
            if (status === RECEIVED) {
                // Allow edit if submission date is valid AND quotation is not complete
                return !isQuotationComplete();
            }

            // For UNDER_REVISION status
            if (status === UNDER_REVISION) {
                // Don't allow edit if quotation is complete
                return !isQuotationComplete();
            }

            // Only allow edit for DRAFT, PREDRAFT, and SENT statuses
            return [DRAFT, PREDRAFT, SENT].includes(status);
        };

        // Get unread message count from rowData (assumes API provides this field)
        const unreadMessageCount = rowData?.UnReadCount;
        const hasUnreadMessages = unreadMessageCount > 0;

        return (
            <>
            {/* Notification button - Shows when vendor sends chat messages */}
                    <button
                        title={`${unreadMessageCount} unread message${unreadMessageCount > 1 ? 's' : ''}`}
                        id='RfqListing_notification'
                        className="btn-notification-alert mr-1 p-relative"
                        type={'button'}
                        onClick={() => viewDetails(rowData)}
                    >
                        <div className='notification-bell-icon'></div>
                        {hasUnreadMessages && (
                            <span className="badge-notification-count">
                                {unreadMessageCount > 0 ? unreadMessageCount : ''}
                            </span>
                        )}
                    </button>
                {/* View button */}
                {(viewAccessibility || permissionData?.permissionDataVendor?.View) &&
                    <button
                        title='View'
                        className="View mr-1 Tour_List_View"
                        type={'button'}
                        onClick={() => viewOrEditItemDetails(cellValue, rowData, true, false)}
                    />
                }

                {/* Edit button */}
                {isEditableStatus() && (editAccessibility || permissionData?.permissionDataVendor?.Edit) &&
                    <button
                        title='Edit'
                        className="Edit mr-1 Tour_List_Edit"
                        type={'button'}
                        onClick={() => viewOrEditItemDetails(cellValue, rowData, false, true)}
                    />
                }

                {/* Cancel button */}
                {(status === DRAFT || status === PREDRAFT || status === SENT) &&
                    rowData?.IsShowCancelIcon &&
                    <button
                        title='Cancel'
                        className="CancelIcon mr-1 Tour_List_Cancel"
                        type={'button'}
                        onClick={() => cancelItem(cellValue)}
                    />
                }

                {/* Remark History button */}
                {hideRemarkHistoryIcon &&
                    <button
                        title='Remark History'
                        id='ViewRfq_remarkHistory'
                        className="btn-history-remark mr-1"
                        type={'button'}
                        onClick={() => getRemarkHistory(cellValue, rowData)}
                    >
                        <div className='history-remark'></div>
                    </button>
                }
            </>
        );
    };

    // Action renderer for Approval Tab: Only show Delete button for Draft status
    const approvalActionFormatter = (props) => {
        const cellValue = props?.valueFormatted ? props?.valueFormatted : props?.value;
        const rowData = props?.valueFormatted ? props?.valueFormatted : props?.data;
        const status = rowData?.Status;

        return (
            <>
                {/* Delete button - Only show for Draft status */}
                {status === DRAFT && (
                    <button
                        title='Cancel'
                        className="CancelIcon mr-1"
                        type={'button'}
                        onClick={() => cancelItem(cellValue)}
                    />
                )}
            </>
        );
    };

    const formToggle = () => {
        setShowAddFrom(true)
        let data = {
            isAddFlag: true,
            isEditFlag: false,
            isViewFlag: false,

        }
        setAddRfqData(data)
    }

    const closeDrawer = () => {
        setAddRfqData({})
        setShowAddFrom(false)
        // setAddRfq(false)
        resetState()
    }


    const closeDrawerViewRfq = () => {
        dispatch(agGridStatus("", ""));
        setFloatingFilterData(prev => ({
            ...prev,
            Status: ""
        }));
        setViewRfq(false);
        setCloseViewRfq(true);
        resetState()
    };


    const onGridReady = (params) => {
        agGridRef.current = params.api;
        setgridApi(params.api);
        params.api.paginationGoToPage(0);
    };

    const buildApprovalDetailsFromListing = (
        row,
        apiData,
        approvalRFQId,
        approvalTypeIdForApi,
        selectedRows,
        flags = {}
    ) => {
        return {
            // Approval Flow Flags
            IsFinalApprover: flags?.IsFinalApprover ?? false,
            IsUserInApprovalFlow: flags?.IsUserInApprovalFlow ?? true,
            IsNextLevelUserExist: flags?.IsNextLevelUserExist ?? false,
            // Organization Context
            DepartmentId: row?.DepartmentId,
            DepartmentName: row?.DepartmentName,
            DivisionId: row?.DivisionId,
            PlantId: row?.PlantId,
            PlantName: row?.PlantName,
            // Approval Level Information
            SenderLevelId: apiData?.SenderLevelId || '00000000-0000-0000-0000-000000000000',
            ApproverLevelId: apiData?.ApproverLevelId || '00000000-0000-0000-0000-000000000000',
            // Technology & Part Context
            ApprovalRFQId: approvalRFQId,
            TechnologyName: row?.TechnologyName,
            PartType: row?.PartType,
            // Approval Process Identifiers
            // ApprovalTypeId extracted from common function: costingTypeIdToApprovalTypeIdFunction(RFQAPPROVALTYPEID ?? '10')
            ApprovalTypeId: approvalTypeIdForApi,
            ApprovalNumber: row?.ApprovalNumber,
            ApprovalProcessId: row?.ApprovalProcessId,
            ApprovalProcessSummaryId: row?.ApprovalProcessSummaryId,
            // RFQ Context Data
            QuotationId: row?.QuotationId,
            QuotationNumber: row?.QuotationNumber,
            PartNumber: row?.PartNumber,
            RawMaterial: row?.RawMaterial,
            BoughtOutPart: row?.BoughtOutPart,
            VendorName: row?.VendorName,
            NoOfQuotationReceived: row?.NoOfQuotationReceived,
            Status: row?.Status,
            DisplayStatus: row?.DisplayStatus,
            // Approver Information
            InitiatedBy: row?.InitiatedBy,
            CurrentApprovalLevel: row?.CurrentApprovalLevel,
            CurrentApproverName: row?.CurrentApproverName,
            LastApprovedBy: row?.LastApprovedBy,
            RejectedBy: row?.RejectedBy,
            // Timestamps
            RaisedOn: row?.RaisedOn,
            RequestedOn: row?.RequestedOn,
            CreatedOn: row?.CreatedOn,
            // Multi-select data (all selected rows)
            SelectedRows: selectedRows,
            TotalSelectedCount: selectedRows?.length || 0,
        };
    };

    // Handler: Send for Approval button click from Approval Listing - Calls checkFinalUser API
    const handleSendForApprovalFromListing = useCallback(() => {
        if (selectedRows.length === 0) {
            Toaster.warning('Please select at least one RFQ to send for approval');
            return;
        }

        // All multi-select validations are enforced during row selection now.

        // Get the first selected row for approval data
        const firstRow = selectedRows[0];

        // Get status - prioritize DisplayStatus, fallback to Status
        // Handle both "PendingForApproval" (no space) and "Pending for Approval" (with space)
        let displayStatus = firstRow?.DisplayStatus || firstRow?.Status || '';

        // Normalize status to handle different formats
        const normalizedStatus = displayStatus.replace(/\s+/g, '').toLowerCase();


        // Extract values needed for buildApprovalDetailsFromListing
        const ApprovalRFQId = getRFQIdByPartType(firstRow?.PartType);
        const approvalTypeIdForApi = costingTypeIdToApprovalTypeIdFunction(RFQAPPROVALTYPEID ?? '10') || '10';

        // Build checkFinalUser API payload using helper
        const checkFinalUserPayload = buildCheckFinalUserPayload(firstRow);

        // Call checkFinalUser API (single call to check approval flow)
        dispatch(checkFinalUser(checkFinalUserPayload, (response) => {
            let data = response?.data?.Data
            setFinalUserDetails(data)
            if (response?.data?.Result) {
                const apiData = response?.data?.Data;

                // ========================================
                // CONDITION 1: User NOT in approval flow
                // ========================================
                if (apiData?.IsUserInApprovalFlow === false) {
                    Toaster.warning('You are not part of the approval flow.');
                    return;
                }

                // ========================================
                // CONDITION 2: Draft + Final Level + User in Approval Flow + No Next Level
                // → Open Approve/Reject Drawer (NO approver selection)
                // ========================================
                if (normalizedStatus === 'draft' && apiData?.IsFinalApprover === true && apiData?.IsUserInApprovalFlow === true && apiData?.IsNextLevelUserExist === false) {
                    // Build approve/reject data directly from listing row with all selected rows
                    const approvalDetailsData = buildApprovalDetailsFromListing(
                        firstRow,
                        apiData,
                        ApprovalRFQId,
                        approvalTypeIdForApi,
                        selectedRows,
                        { IsFinalApprover: true, IsUserInApprovalFlow: true, IsNextLevelUserExist: false }
                    );
                    setRfqApprovalNumber(firstRow?.ApprovalNumber);
                    setRfqApprovalProcessId(firstRow?.ApprovalProcessId);
                    setApproveRejectDetails(approvalDetailsData);
                    setShowApproveRejectDrawer(true);
                    return;
                }

                // ========================================
                // CONDITION 3: Draft + Not Final Level + User in Approval Flow + Next Level User Exists
                // → Open Send for Approval Drawer (WITH approver selection)
                // ========================================


                if (normalizedStatus === 'draft' && apiData?.IsFinalApprover === false && apiData?.IsUserInApprovalFlow === true && apiData?.IsNextLevelUserExist === true) {
                    // Build payload directly from approval listing row (no fetch)
                    const quotationId = firstRow?.QuotationId;
                    if (!quotationId) {
                        Toaster.error('Quotation ID not found');
                        return;
                    }
                    setRfqDrawerMode('approve');
                    setRfqIsFinalApprover(false);
                    setRfqApprovalNumber(null);
                    setRfqApprovalProcessId(null);
                    const cleanRfqPayload = {
                        QuotationId: quotationId,
                        QuotationNumber: firstRow?.QuotationNumber || null,
                        Remark: firstRow?.Remark || null,
                        PartType: firstRow?.PartType || null,
                        ApprovalRFQId: getRFQIdByPartType(firstRow?.PartType) ? parseInt(getRFQIdByPartType(firstRow?.PartType), 10) : (firstRow?.TechnologyId || null),
                        PlantId: null,
                        LoggedInUserId: loggedInUserId(),
                        StatusId: null,
                        IsSent: true,
                        IsConditionallyVisible: firstRow?.IsConditionallyVisible || false,
                        VisibilityMode: firstRow?.VisibilityMode || null,
                        VisibilityDate: firstRow?.VisibilityDate || null,
                        VisibilityDuration: firstRow?.VisibilityDuration || null,
                        LastSubmissionDate: firstRow?.LastSubmissionDate ? DayTime(firstRow.LastSubmissionDate).format('YYYY-MM-DD HH:mm:ss') : null,
                        VendorList: firstRow?.VendorList && firstRow?.VendorList.length > 0 ? firstRow?.VendorList : null,
                        Timezone: firstRow?.TimeZone || getTimeZone() || null,
                        Attachments: firstRow?.Attachments && firstRow?.Attachments.length > 0 ? firstRow?.Attachments : [],
                        NfrId: firstRow?.NfrId || null,
                        PartList: [],
                        PrNumberId: firstRow?.PRNumberId || null,
                        PartDataSentOn: firstRow?.PartDataSentDate || null,
                        IsPartDetailsSent: firstRow?.IsPartDetailsSent || false,
                        HitRatePerDay: firstRow?.HitRatePerDay || null,
                        PlantList: Array.isArray(firstRow?.PlantList) && firstRow.PlantList.length > 0
                            ? firstRow.PlantList
                            : (firstRow?.PlantId ? [{ PlantId: firstRow.PlantId, Plant: firstRow.PlantName }] : [])
                    };
                    setRfqDataForApproval(cleanRfqPayload);
                    setSendForApprovalDrawerOpen(true);
                    return;
                }

                // ========================================
                // CONDITION 4: PendingForApproval + Final Level + User in Approval Flow
                // → Open Approve/Reject Drawer (NO approver selection)
                // ========================================

                if (normalizedStatus === 'pendingforapproval' && apiData?.IsFinalApprover === true && apiData?.IsUserInApprovalFlow === true) {
                    // if (!firstRow?.ApprovalNumber || !firstRow?.ApprovalProcessId) {
                    //     Toaster.error('Approval details not found. Please refresh and try again.');
                    //     return;
                    // }
                    const approvalDetailsData = buildApprovalDetailsFromListing(
                        firstRow,
                        apiData,
                        ApprovalRFQId,
                        approvalTypeIdForApi,
                        selectedRows,
                        { IsFinalApprover: true, IsUserInApprovalFlow: true, IsNextLevelUserExist: false }
                    );
                    setRfqApprovalNumber(firstRow?.ApprovalNumber);
                    setRfqApprovalProcessId(firstRow?.ApprovalProcessId);
                    setApproveRejectDetails(approvalDetailsData);
                    setShowApproveRejectDrawer(true);
                    return;
                }

                // ========================================
                // CONDITION 5: PendingForApproval + Not Final Level + User in Approval Flow + Next Level User Exists
                // → Open Approve/Reject Drawer (WITH approver selection)
                // ========================================

                if (normalizedStatus === 'pendingforapproval' && apiData?.IsFinalApprover === false && apiData?.IsUserInApprovalFlow === true && apiData?.IsNextLevelUserExist === true) {
                    // if (!firstRow?.ApprovalNumber || !firstRow?.ApprovalProcessId) {
                    //     Toaster.error('Approval details not found. Please refresh and try again.');
                    //     return;
                    // }
                    const approvalDetailsData = buildApprovalDetailsFromListing(
                        firstRow,
                        apiData,
                        ApprovalRFQId,
                        approvalTypeIdForApi,
                        selectedRows,
                        { IsFinalApprover: false, IsUserInApprovalFlow: true, IsNextLevelUserExist: true }
                    );
                    setRfqApprovalNumber(firstRow?.ApprovalNumber);
                    setRfqApprovalProcessId(firstRow?.ApprovalProcessId);
                    setApproveRejectDetails(approvalDetailsData);
                    setShowApproveRejectDrawer(true);
                    return;
                }

                // ========================================
                // CONDITION 6: No next level approver exists
                // ========================================
                if (apiData?.IsNextLevelUserExist === false) {
                    Toaster.warning('No next level approvers exist for this RFQ');
                    return;
                }

                // ========================================
                // CATCH-ALL: No condition matched
                // ========================================

                Toaster.warning(`No valid action available for status: ${displayStatus}`);
            } else {
                Toaster.error('Failed to check approval flow');
            }
        }, (error) => {
            Toaster.error('Failed to check approval flow');
        }));
    }, [selectedRows, dispatch]);



    // Handler: Close Send for Approval Drawer
    const handleSendForApprovalDrawerClose = useCallback((type) => {
        setSendForApprovalDrawerOpen(false);
        setRfqDataForApproval(null);
        // Refresh the grid after approval is sent
        if (type === 'submit') {
            getDataList(0, globalTakes, true);
            gridApi?.deselectAll();
        }
    }, [gridApi, globalTakes, getDataList]);

    // Handler: Close Approve/Reject Drawer
    const handleApproveRejectDrawerClose = useCallback((event, closeType) => {
        setShowApproveRejectDrawer(false);

        // Refresh grid if submission was successful
        if (closeType === 'submit' || closeType === 'reject') {
            getDataList();
            gridApi?.deselectAll();
        }
    }, [gridApi]);


    // Handler: Approval Number hyperlink click - Opens RFQ in view mode with approval workflow
    const handleApprovalNumberClick = useCallback((approvalNumber, rowData) => {
        if (!approvalNumber) {
            Toaster.error('Approval Number not found');
            return;
        }
        const quotationId = rowData?.QuotationId;
        if (!quotationId) {
            Toaster.error('Quotation ID not found');
            return;
        }

        // Build checkFinalUser API payload using helper
        const checkFinalUserPayload = buildCheckFinalUserPayload(rowData);

        dispatch(checkFinalUser(checkFinalUserPayload, (response) => {
            let data = response?.data?.Data
            setFinalUserDetails(data)
            if (response?.data?.Result) {
                const approvalData = response?.data?.Data;

                // Add approval data to rowData for ViewRfq to use
                const enrichedRowData = {
                    ...rowData,
                    showApprovalWorkflow: true,
                    ApprovalNumber: approvalNumber,
                    ApprovalProcessSummaryId: rowData?.ApprovalProcessSummaryId,
                    IsFinalApprover: approvalData?.IsFinalApprover || false,
                    SenderLevelId: approvalData?.SenderLevelId,
                    ApproverLevelId: approvalData?.ApproverLevelId
                };

                // Open RFQ in VIEW mode with approval data
                viewOrEditItemDetails(quotationId, enrichedRowData, true, false);
            } else {
                Toaster.error('Failed to fetch approval details');
            }
        }));
    }, [dispatch]);

    // Handler: Row selection changed (for Send for Approval)
    /**
     * Handle row selection with pagination persistence
     * Similar to CommonApproval.js:535-612
     */
    const onRowSelect = useCallback((event) => {
        if ((!isApprovalTab && !isDashboard) || !gridApi) return;

        // Get currently selected rows on this page
        var selectedRowsOnCurrentPage = gridApi.getSelectedRows();

        // 1. First rendering - use reducer data if available
        if (selectedRowsOnCurrentPage === undefined || selectedRowsOnCurrentPage === null) {
            selectedRowsOnCurrentPage = selectedRowForPagination || [];
        }
        // 2. Check if reducer has data from previous pages
        else if (selectedRowForPagination && selectedRowForPagination.length > 0) {
            let finalData = [];

            // 3. If current checkbox is UNSELECTED, remove from reducer
            if (event.node.isSelected() === false) {
                for (let i = 0; i < selectedRowForPagination.length; i++) {
                    // Remove unchecked item by comparing QuotationId
                    if (selectedRowForPagination[i]?.QuotationId === event?.data?.QuotationId) {
                        continue; // Skip this item (effectively removing it)
                    }
                    finalData.push(selectedRowForPagination[i]);
                }
            } else {
                // If selected, keep all previous data
                finalData = selectedRowForPagination;
            }

            // Merge current page selections with previous page selections
            selectedRowsOnCurrentPage = [...selectedRowsOnCurrentPage, ...finalData];
        }

        // 4. Remove duplicates using lodash uniqBy on QuotationId
        const uniqueSelectedRows = _.uniqBy(selectedRowsOnCurrentPage, (item) => String(item?.QuotationId ?? ''));

        // 5. SELECTION VALIDATIONS: Enforce same Status, PartType, Plant and Department at selection time
        if (uniqueSelectedRows.length > 1 && event.node.isSelected() === true) {
            const first = uniqueSelectedRows[0];
            const firstStatus = first?.Status || first?.DisplayStatus;
            const firstPartType = first?.PartType;
            const firstDepartmentId = first?.DepartmentId;

            // Status
            const allSameStatus = uniqueSelectedRows.every(item => (item?.Status || item?.DisplayStatus) === firstStatus);
            if (!allSameStatus) {
                event.node.setSelected(false);
                Toaster.warning('Status should be same for sending RFQs for approval');
                return;
            }

            // Part Type
            const allSamePartType = uniqueSelectedRows.every(item => item?.PartType === firstPartType);
            if (!allSamePartType) {
                event.node.setSelected(false);
                Toaster.warning('Please select RFQs with the same Part Type.');
                return;
            }

            // Department
            const allSameDepartment = uniqueSelectedRows.every(item => item?.DepartmentId === firstDepartmentId);
            if (!allSameDepartment) {
                event.node.setSelected(false);
                Toaster.warning('Please select RFQs with the same Department.');
                return;
            }
        }

        // 6. Update Redux (for cross-page persistence) and local state
        dispatch(setSelectedRowForPagination(uniqueSelectedRows));
        setSelectedRows(uniqueSelectedRows);

        // Disable button if no rows selected
        setDisableApprovalButton(uniqueSelectedRows.length === 0);
    }, [isApprovalTab, isDashboard, gridApi, selectedRowForPagination, dispatch]);

    const onFilterTextBoxChanged = (e) => {
        gridApi.setQuickFilter(e.target.value);
    }


    const linkableFormatter = (props) => {

        const cell = props?.valueFormatted ? props?.valueFormatted : props?.value;
        const row = props?.valueFormatted ? props?.valueFormatted : props?.data;

        if (row?.IsActive) {
            return (
                <>
                    <div
                        id='showRfq_detail'
                        onClick={() => viewDetails(row)}
                        className={'link'}
                    >{cell}</div>
                </>
            )
        } else {

            return cell ? cell : "-"

        }
    }
    const quotationReceiveFormatter = (props) => {

        const cell = props?.valueFormatted ? props?.valueFormatted : props?.value;
        const row = props?.valueFormatted ? props?.valueFormatted : props?.data;

        if (row?.IsActive) {
            return (
                <>
                    {cell >= 1 ? <div
                        onClick={() => viewDetails(row)}
                        className={'link'}
                    >{cell}</div> : <div>{cell}</div>}
                </>
            )
        } else {

            return cell ? cell : "-"

        }
    }
    const statusFormatter = (props) => {
        dispatch(getGridHeight({ value: agGridRef.current.rowRenderer.allRowCons.length, component: 'RFQ' }))
        const cell = props?.valueFormatted ? props?.valueFormatted : props?.value;
        const row = props?.valueFormatted ? props?.valueFormatted : props?.data;
        let tempStatus = '-'
        if (isApprovalTab || isDashboard) {
            tempStatus = row?.DisplayStatus ?? '-'
        }
        else if (row?.Status === APPROVED || row?.Status === UNDER_REVISION || row?.Status === RECEIVED || row?.Status === SUBMITTED || row?.Status === UNDER_APPROVAL) {
            tempStatus = row?.DisplayStatus + ' (' + row?.CostingReceived + '/' + row?.TotalCostingCount + ')'
        } else {
            tempStatus = row?.DisplayStatus ?? '-'
        }
        return <div className={cell}>{tempStatus}</div>
    }

    const viewAttachmentData = (index) => {
        setAttachment(true)
        setViewAttachment(index)
    }

    const closeAttachmentDrawer = (e = '') => {
        setAttachment(false)
    }
    const dashFormatter = (props) => {
        const cellValue = props?.value;
        return cellValue ? cellValue : '-';
    }


    const dateFormatter = (props) => {
        const cellValue = props?.valueFormatted ? props?.valueFormatted : props?.value;
        return cellValue != null ? DayTime(cellValue).format('DD/MM/YYYY') : '-';
    }

    const dateTimeFormatter = (props) => {
        const cellValue = props?.valueFormatted ? props?.valueFormatted : props?.value;
        return cellValue != null ? DayTime(cellValue).format('DD/MM/YYYY  hh:mm') : '-';
    }


    const attachmentFormatter = (props) => {
        const row = props?.valueFormatted ? props?.valueFormatted : props?.data;
        let files = row?.Attachments

        return (
            <>
                <div className={"attachment images"}>
                    {files && files.length === 1 ?
                        files.map((f) => {
                            const withOutTild = f.FileURL?.replace("~", "");
                            const fileURL = `${FILE_URL}${withOutTild}`;
                            return (
                                <a href={fileURL} target="_blank" rel="noreferrer">
                                    {f.OriginalFileName}
                                </a>
                            )

                        }) : <button
                            type='button'
                            title='View Attachment'
                            className='btn-a pl-0'
                            onClick={() => viewAttachmentData(row)}
                        >View Attachment</button>}
                </div>
            </>
        )

    }


    const viewDetails = (rowData) => {
        if (!rowData?.QuotationId) {
            Toaster.error('Quotation ID not found');
            return;
        }
        setViewRfqData(rowData)
        setViewRfq(true)
        resetState()
    }

    // Helper: Check if column is first column AND on approval tab
    const isFirstColumn = (params) => {
        if (!isApprovalTab) return false; // Only show checkboxes on Approval tab
        const displayedColumns = params.columnApi.getAllDisplayedColumns();
        const thisIsFirstColumn = displayedColumns[0] === params.column;
        return thisIsFirstColumn;
    };

    /**
     * Check if checkbox should be selectable for this row
     * Similar to CommonApproval.js:848-854
     * Only Draft and PendingForApproval rows can be selected
     * @param {Object} rowNode - AG-Grid row node object
     */
    const isRowSelectable = (rowNode) => {
        if (!isApprovalTab) return false;

        // Get both Status and DisplayStatus to handle different data structures
        const status = rowNode?.data?.Status || '';
        const displayStatus = rowNode?.data?.DisplayStatus || '';

        // Check for Draft status
        const isDraft = status === 'Draft' || displayStatus === 'Draft';

        // Check ONLY for PendingForApproval (handle with/without space)
        const isPendingForApproval = status === 'PendingForApproval' ||
            displayStatus === 'PendingForApproval' ||
            displayStatus === 'Pending for Approval';

        return isDraft || isPendingForApproval;
    };

    const defaultColDef = {
        resizable: true,
        filter: true,
        sortable: false,
        checkboxSelection: isFirstColumn,
        headerCheckboxSelection: isFirstColumn,
        headerCheckboxSelectionFilteredOnly: true,
    };
    const hyphenFormatter = (props) => {


        const cellValue = props?.value;
        return cellValue !== " " &&
            cellValue !== null &&
            cellValue !== "" &&
            cellValue !== undefined
            ? cellValue
            : "-";
    };
    const closeRemarkDrawer = (type) => {
        setRemarkHistoryDrawer(false)
    }

    // Custom renderer: Approval Number as hyperlink (Phase 1 - Placeholder)
    const approvalNumberLinkRenderer = (props) => {
        const approvalNumber = props?.value;
        const rowData = props?.data;

        if (!approvalNumber) return '-';

        return (
            <div
                onClick={() => handleApprovalNumberClick(approvalNumber, rowData)}
                className="link"
            >
                {approvalNumber}
            </div>
        );
    };

    const frameworkComponents = {
        totalValueRenderer: buttonFormatter,
        approvalActionRenderer: approvalActionFormatter,
        linkableFormatter: linkableFormatter,
        approvalNumberLinkRenderer: approvalNumberLinkRenderer,
        customNoRowsOverlay: NoContentFound,
        quotationReceiveFormatter: quotationReceiveFormatter,
        attachmentFormatter: attachmentFormatter,
        statusFormatter: statusFormatter,
        dateFormatter: dateFormatter,
        dashFormatter: dashFormatter,
        dateTimeFormatter: dateTimeFormatter,
        valuesFloatingFilter: SingleDropdownFloationFilter,
        hyphenFormatter: hyphenFormatter,
        cellRendererFramework: CustomCellRenderer
    }


    return (
        <>
            {!showAddFrom && permissionData !== undefined &&
                <div className={`ag-grid-react report-grid p-relative  ${(props?.isMasterSummaryDrawer === undefined || props?.isMasterSummaryDrawer === false) ? "" : ""} ${true ? "show-table-btn" : ""} ${false ? 'simulation-height' : props?.isMasterSummaryDrawer ? '' : 'min-height100vh'}`}>
                    {(loader ? <LoaderCustom customClass="simulation-Loader" /> : !viewRfq && (
                        <>
                            <Row className={`filter-row-large pt-2 ${props?.isSimulation ? 'zindex-0 ' : ''}`}>

                                <Col md="3" lg="3" className='mb-2'>

                                    <input type="text" className="form-control table-search" id="filter-text-box" placeholder="Search " autoComplete={'off'} onChange={(e) => onFilterTextBoxChanged(e)} />
                                    <TourWrapper
                                        buttonSpecificProp={{ id: "Rfq_listing_Tour", onClick: toggleExtraData }}
                                        stepsSpecificProp={{
                                            steps: Steps(t, { Cancel: true, showRfqDetail: true, filterButton: false, downloadButton: false, bulkUpload: false, DeleteButton: false, costMovementButton: false, addLimit: false, copyButton: false, viewBOM: false, status: false, updateAssociatedTechnology: false, addMaterial: false, addAssociation: false, generateReport: false, approve: false, reject: false }).COMMON_LISTING
                                        }} />
                                </Col>
                                <Col md="9" lg="9" className="mb-3 d-flex justify-content-end">
                                    {
                                        // SHOW FILTER BUTTON ONLY FOR RM MASTER NOT FOR SIMULATION AMD MASTER APPROVAL SUMMARY
                                        (!props?.isMasterSummaryDrawer) &&
                                        <>
                                            <div className="d-flex justify-content-end bd-highlight w100">
                                                <>
                                                    {(props?.isMasterSummaryDrawer === undefined || props?.isMasterSummaryDrawer === false) &&
                                                        <div className="warning-message d-flex align-items-center">
                                                            {warningMessage && (<><WarningMessage dClass="mr-3" message={'Please click on filter button to filter all data'} /><div className='right-hand-arrow mr-2'></div></>)}
                                                        </div>
                                                    }
                                                    {

                                                        <Button
                                                            id="rfqlisting_filter"
                                                            className={"mr5 Tour_List_Filter"}
                                                            onClick={() => onSearch()}
                                                            title={"Filtered data"}
                                                            icon={"filter"}
                                                            disabled={!warningMessage}
                                                        />

                                                    }

                                                    {!isApprovalTab && (addAccessibility || permissionData?.permissionDataVendor?.Add) && (<button
                                                        type="button"
                                                        className={"user-btn mr5 Tour_List_Add"}
                                                        onClick={formToggle}
                                                        title="Add"
                                                    >
                                                        <div className={"plus mr-0"}></div>
                                                        {/* ADD */}
                                                    </button>)}

                                                </>
                                            </div>

                                            <button type="button" className="user-btn" title="Reset Grid" onClick={() => resetState()}>
                                                <div className="refresh mr-0 Tour_List_Reset"></div>
                                            </button>

                                            {/* Send For Approval, Approve and Reject Buttons - Only show on Approval tab */}
                                            {isApprovalTab && (
                                                <>
                                                    <Button
                                                        id="rfq_send_for_approval"
                                                        className="ml5"
                                                        variant="user-btn approval-btn"
                                                        title="Send For Approval"
                                                        onClick={handleSendForApprovalFromListing}
                                                        icon="send-for-approval"
                                                        disabled={selectedRows.length === 0 || disableApprovalButton}
                                                    />

                                                </>
                                            )}
                                        </>
                                    }
                                </Col>

                            </Row>
                            <Row>
                                <Col>
                                    <div className={`ag-grid-wrapper ${(props?.isDataInMaster && noData) ? 'master-approval-overlay' : ''} ${(rowData && rowData?.length <= 0) || noData ? 'overlay-contain' : ''}`}>
                                        <div className={`ag-theme-material ${(loader) && "max-loader-height"}`}>
                                            {noData && <NoContentFound title={EMPTY_DATA} customClassName="no-content-found" />}

                                            {render ? <LoaderCustom customClass="loader-center" /> :

                                                <AgGridReact
                                                    style={{ height: '100%', width: '100%' }}
                                                    defaultColDef={defaultColDef}
                                                    floatingFilter={true}
                                                    ref={agGridRef}
                                                    domLayout='autoHeight'
                                                    rowData={
                                                        isApprovalTab
                                                            ? (approvalStatusList?.data || [])
                                                            : (showExtraData ? [...setLoremIpsum(rowData[0]), ...rowData] : rowData)
                                                    }
                                                    // pagination={true}
                                                    paginationPageSize={globalTakes}
                                                    onGridReady={onGridReady}
                                                    gridOptions={gridOptions}
                                                    noRowsOverlayComponent={'customNoRowsOverlay'}
                                                    noRowsOverlayComponentParams={{
                                                        title: EMPTY_DATA,
                                                        imagClass: 'imagClass'
                                                    }}
                                                    frameworkComponents={frameworkComponents}
                                                    rowSelection={'multiple'}
                                                    suppressRowClickSelection={true}
                                                    isRowSelectable={isRowSelectable}
                                                    onRowSelected={onRowSelect}
                                                    onFilterModified={onFloatingFilterChanged}
                                                    enableBrowserTooltips={true}
                                                >
                                                    {/* Conditional: Show Approval Number for Approval Tab, RFQ No for Listing Tab */}
                                                    {isApprovalTab ? (
                                                        <>
                                                            <AgGridColumn
                                                                width={160}
                                                                cellClass="has-checkbox"
                                                                field="ApprovalNumber"
                                                                headerName="Approval Number"
                                                                cellRenderer={'approvalNumberLinkRenderer'}
                                                            />
                                                            <AgGridColumn
                                                                width={150}
                                                                field="QuotationNumber"
                                                                headerName='RFQ No.'
                                                                cellRenderer={'hyphenFormatter'}
                                                            />
                                                        </>
                                                    ) : (
                                                        <AgGridColumn cellClass="has-checkbox" field="QuotationNumber" headerName='RFQ No.' cellRenderer={'linkableFormatter'} ></AgGridColumn>
                                                    )}
                                                    {!isApprovalTab && initialConfiguration?.RFQManditField?.IsShowNFRNo && <AgGridColumn field="NfrId" headerName='NFR Id' width={150}></AgGridColumn>}
                                                    <AgGridColumn field="PartType" headerName="Part Type" width={150} cellRenderer={"hyphenFormatter"}></AgGridColumn>
                                                    <AgGridColumn field="PartNumber" tooltipField="PartNumber" headerName="Part Name (Part No.)" width={150} cellRendererFramework={CustomCellRenderer} />
                                                    {RFQ_KEYS?.SHOW_RM && <AgGridColumn field="RawMaterial" tooltipField="PartNumber" headerName="Raw Material Name-Grade-Specification" width={230} cellRendererFramework={CustomCellRenderer}></AgGridColumn>}
                                                    {RFQ_KEYS?.SHOW_BOP && <AgGridColumn field="BoughtOutPart" headerName={`${showBopLabel()} Name (${showBopLabel()} No.)`} width={200} cellRendererFramework={CustomCellRenderer}></AgGridColumn>}
                                                    {initialConfiguration?.RFQManditField?.IsShowPRNumber && (RFQ_KEYS?.SHOW_BOP || RFQ_KEYS?.SHOW_TOOLING) && <AgGridColumn field="PRNumber" headerName="PR No." width={150} cellRenderer={"hyphenFormatter"}></AgGridColumn>}

                                                    <AgGridColumn field="NoOfQuotationReceived" headerName='Quotation Received (No.)' maxWidth={150} cellRenderer={'quotationReceiveFormatter'}></AgGridColumn>
                                                    <AgGridColumn field="VendorName" tooltipField="VendorName" headerName={vendorLabel + " (Code)"} cellRendererFramework={CustomCellRenderer}></AgGridColumn>
                                                    <AgGridColumn field="PlantName" tooltipField="PlantName" headerName='Plant (Code)' cellRendererFramework={CustomCellRenderer}></AgGridColumn>
                                                    <AgGridColumn field="TechnologyName" width={"160px"} headerName={technologyLabel}></AgGridColumn>
                                                    {initialConfiguration?.IsManageSeparateUserPermissionForPartAndVendorInRaiseRFQ && <AgGridColumn field="RaisedBy" width={"160px"} headerName='Initiated By'></AgGridColumn>}
                                                    <AgGridColumn field="RaisedBy" headerName='Raised By' cellRenderer='dashFormatter' ></AgGridColumn>
                                                    <AgGridColumn field="RaisedOn" headerName="Raised On" cellRenderer="dateFormatter" filter="agDateColumnFilter" filterParams={raisedOnFilterParams} />
                                                    {initialConfiguration?.IsManageSeparateUserPermissionForPartAndVendorInRaiseRFQ && <AgGridColumn field="PartDataSentDate" headerName="RFI Date" cellRenderer="dateFormatter" filter="agDateColumnFilter" filterParams={partDataSentFilterParams} />}
                                                    <AgGridColumn field="VisibilityMode" width={"200px"} headerName='Visibility Mode' cellRenderer='dashFormatter'></AgGridColumn>
                                                    <AgGridColumn field="VisibilityDate" headerName="Visibility Date" cellRenderer="dateTimeFormatter" filter="agDateColumnFilter" filterParams={visibilityDateFilterParams} />
                                                    <AgGridColumn field="VisibilityDuration" width={"150px"} headerName='Visibility Duration' cellRenderer='dashFormatter'></AgGridColumn>
                                                    {/* <AgGridColumn field="TimeZone" width={"150px"} headerName='Time Zone' cellRenderer='timeZoneFormatter'></AgGridColumn> */}
                                                    <AgGridColumn field="LastSubmissionDate" headerName="Last Submission Date" cellRenderer="dateFormatter" filter="agDateColumnFilter" filterParams={lastSubmissionDateFilterParams} />
                                                    <AgGridColumn field="QuotationNumber" floatingFilter={false} headerName='Attachments' cellRenderer='attachmentFormatter'></AgGridColumn>
                                                    <AgGridColumn field="Remark" tooltipField="Remark" headerName='Notes' cellRenderer={"hyphenFormatter"}></AgGridColumn>

                                                    {/* Approval-specific columns */}
                                                    {isApprovalTab && (
                                                        <>
                                                            <AgGridColumn
                                                                width={150}
                                                                field="RequestedBy"
                                                                headerName="Initiated By"
                                                                cellRenderer='dashFormatter'
                                                            />
                                                            <AgGridColumn
                                                                width={150}
                                                                field="CreatedBy"
                                                                headerName="Created By"
                                                                cellRenderer='dashFormatter'
                                                            />
                                                            <AgGridColumn
                                                                width={150}
                                                                field="DepartmentName"
                                                                headerName="Department"
                                                                cellRenderer='dashFormatter'
                                                            />
                                                            <AgGridColumn
                                                                width={180}
                                                                field="RequestedOn"
                                                                headerName="Requested On"
                                                                cellRenderer='dateTimeFormatter'
                                                            />
                                                            <AgGridColumn
                                                                width={150}
                                                                field="Reason"
                                                                headerName="Reason"
                                                                cellRenderer='dashFormatter'
                                                            />
                                                        </>
                                                    )}

                                                    {/* <AgGridColumn field="Status" tooltipField="tooltipText" headerName="Status" headerClass="justify-content-center" cellClass="text-center" cellRenderer="statusFormatter" floatingFilterComponent="valuesFloatingFilter" floatingFilterComponentParams={floatingFilterRFQ} /> */}
                                                    {/* Hide Status column when in Dashboard mode as status is already filtered by tab */}
                                                    {!isDashboard && <AgGridColumn
                                                        field="Status"
                                                        tooltipField={isApprovalTab ? '' : 'tooltipText'}
                                                        headerName="Status"
                                                        headerClass="justify-content-center"
                                                        cellClass="text-center"
                                                        cellRenderer="statusFormatter"
                                                        floatingFilterComponent="valuesFloatingFilter"
                                                        floatingFilterComponentParams={floatingFilterRFQ}
                                                        floatingFilter={true}
                                                    ></AgGridColumn>}
                                                    {<AgGridColumn
                                                        field="QuotationId"
                                                        width={180}
                                                        cellClass="ag-grid-action-container rfq-listing-action"
                                                        pinned="right"
                                                        headerName="Action"
                                                        type="rightAligned"
                                                        floatingFilter={false}
                                                        cellRenderer={isApprovalTab ? 'approvalActionRenderer' : 'totalValueRenderer'}
                                                    ></AgGridColumn>}

                                                </AgGridReact>}

                                            <div className='button-wrapper'>
                                                {<PaginationWrappers
                                                    gridApi={gridApi}
                                                    totalRecordCount={totalRecordCount}
                                                    getDataList={getDataList}
                                                    floatingFilterData={floatingFilterData}
                                                    module={isApprovalTab ? "RFQApproval" : "RFQ"}
                                                    isApproval={isApprovalTab}
                                                />}
                                                {/* {(props?.isMasterSummaryDrawer === undefined || props?.isMasterSummaryDrawer === false) && */}
                                                <PaginationControls
                                                    totalRecordCount={totalRecordCount}
                                                    getDataList={getDataList}
                                                    floatingFilterData={floatingFilterData}
                                                    module={isApprovalTab ? "RFQApproval" : "RFQ"}
                                                />

                                                {/* } */}

                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>

                        </>))
                    }

                    {viewRfq &&

                        <ViewRfq
                            data={viewRfqData}
                            isOpen={viewRfq}
                            closeDrawer={closeDrawerViewRfq}
                        />

                    }

                    {
                        confirmPopup && <PopupMsgWrapper isOpen={confirmPopup} closePopUp={closePopUp} confirmPopup={onPopupConfirm} message={`${MESSAGES.RFQ_DETAIL_CANCEL_ALERT}`} />
                    }

                </div >
            }
            <ApplyPermission.Provider value={permissionData}>

                {showAddFrom &&

                    <AddRfq
                        data={addRfqData}
                        isRMAssociated={true}
                        isOpen={showAddFrom}
                        anchor={"right"}
                        isEditFlag={addRfqData?.isEditFlag}
                        isViewFlag={addRfqData?.isViewFlag}
                        isAddFlag={addRfqData?.isAddFlag}
                        finalUserDetails={finalUserDetails}
                        closeDrawer={closeDrawer}
                    />

                }
            </ApplyPermission.Provider>


            {
                attachment && (
                    <Attachament
                        isOpen={attachment}
                        index={viewAttachment}
                        closeDrawer={closeAttachmentDrawer}
                        anchor={'right'}
                        gridListing={true}
                    />
                )
            }
            {remarkHistoryDrawer &&
                <RemarkHistoryDrawer
                    data={remarkRowData}
                    //hideForm={hideForm}
                    AddAccessibilityRMANDGRADE={true}
                    EditAccessibilityRMANDGRADE={true}
                    isRMAssociated={true}
                    isOpen={remarkHistoryDrawer}
                    anchor={"right"}
                    isEditFlag={showAddFrom?.isEditFlag}
                    rfqListing={true}
                    closeDrawer={closeRemarkDrawer}
                />
            }
            {/* Send for Approval Drawer - Opens when Send for Approval button is clicked */}
            {sendForApprovalDrawerOpen && rfqDataForApproval && (
                <RFQApprovalDrawer
                    mode="send"
                    isOpen={sendForApprovalDrawerOpen}
                    closeDrawer={handleSendForApprovalDrawerClose}
                    rfqData={rfqDataForApproval}
                    selectedQuotationIdList={(selectedRows || []).map(r => r?.QuotationId).filter(Boolean)}
                    approvalRFQId={getRFQIdByPartType(rfqDataForApproval?.PartType)}
                    plantId={rfqDataForApproval?.PlantId || selectedRows[0]?.PlantId || null}
                    divisionId={rfqDataForApproval?.DivisionId || selectedRows[0]?.DivisionId || null}
                    approvalTypeId={String(costingTypeIdToApprovalTypeIdFunction(RFQAPPROVALTYPEID ?? '10') || '10')}
                    isFinalApprover={rfqIsFinalApprover}
                    approvalNumber={rfqApprovalNumber}
                    approvalProcessId={rfqApprovalProcessId}
                    form ="rfqListing"
                />
            )}

            {/* Approve/Reject Drawer - Opens when Approve or Reject button is clicked from approval listing */}
            {showApproveRejectDrawer && selectedRows?.length > 0 && (
                <RFQApprovalDrawer
                    mode="approve"
                    isOpen={showApproveRejectDrawer}
                    closeDrawer={handleApproveRejectDrawerClose}
                    selectedRowData={selectedRows}
                    approvalDetails={approveRejectDetails}
                    isFinalApprover={approveRejectDetails?.IsFinalApprover || false}
                    approvalProcessId={rfqApprovalProcessId}
                    approvalNumber={rfqApprovalNumber}
                    isFromApprovalTab={isApprovalTab}
                    form ="rfqListing"
                />
            )}

        </>
    );
}

// PropTypes validation
RfqListing.propTypes = {
    isApprovalTab: PropTypes.bool,
    activeTab: PropTypes.string,
    departmentInfo: PropTypes.shape({
        departmentId: PropTypes.string,
        departmentCode: PropTypes.string,
        departmentName: PropTypes.string,
    }),
    approversList: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string,
        value: PropTypes.string,
        levelId: PropTypes.string,
        levelName: PropTypes.string,
        userId: PropTypes.string,
    })),
};

// Default props
RfqListing.defaultProps = {
    isApprovalTab: false,
    activeTab: '1',
    departmentInfo: null,
    approversList: [],
};

export default React.memo(RfqListing);

